// priority nav - filters
var wrapper = document.querySelector(".filter");
var nav = priorityNav.init({
	mainNavWrapper: ".filter",
	navDropdownLabel: "",
	navDropdownBreakpointLabel: "",
	breakPoint: 0,
	throttleDelay: '50'
});